angular.module('tf.directives')
    
.directive('loadImage', function (HttpService) {
    return {
        restrict: 'A',
        scope : {
            item : '=loadImage'
        },
        link: function($scope, element){
            var item = $scope.item;
            if(!item.thumbnail){
                var iconPath='url(img/logo-folder.svg)';
                if(item.type==1){
                    switch (item.sourceType){
                        case 0: iconPath='url(img/logo-ae.svg)';
                            break;
                    }
                }
                element.css({
                    'background-image': iconPath,
                    'background-size': 'contain',
                    'background-repeat':'no-repeat'
                });
            } else {
                HttpService.get('farmer/'+item.fid+'/image/', {image: item.thumbnail})
                    .then(function (res) {
                        element.css({
                            'background-image': 'url(data:image/JPEG;base64,' + res.data + ')',
                            'background-size': 'cover'
                        });
                    });
            }

        }
    };
});